<template>
  <div>
    <h2 class="page-title">TOTAL TEÓRICO: {{ formatPrice(total) }}</h2>
    <h2 class="page-title">TOTAL PEDIDOS: {{ totalLineOrders }}</h2>
    <!--    <h2 class="page-title">-->
    <!--      TOTAL PEDIDOS: {{ totalOrders }}-->
    <!--      <span style="font-size:16px;"-->
    <!--      >(TOTAL LINEAS DE PEDIDO: {{ totalLineOrders }})</span-->
    <!--      >-->
    <!--    </h2>-->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="reversedOrders"
          :headers="headers"
          no-data-text="No se han encontrado resultados !"
          class="elevation-1"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
        >
          <template v-slot:[`item.time`]="{ item }">
            <span class="day-format">{{ dayFormatLL(item.time) }}</span>
            {{ formatTime(item.time) }}
          </template>
          <template v-slot:[`item.name`]="{ item }">
            {{ item.name + weight(item) }}
          </template>
          <template v-slot:[`item.orderType`]="{ item }">
            {{ getType(item) }}
          </template>
          <template v-slot:[`item.email`]="{ item }">
            <div :title="item.email" class="text-truncate">
              {{ item.email || " " }}
            </div>
          </template>
          <template v-slot:[`item.quantity`]="{ item }">
            {{ item.quantity }} x
          </template>
          <template v-slot:[`item.isPending`]="{ item }">
            {{ item.isPending ? "Pendientes" : "Hechos" }}
          </template>
          <template v-slot:[`item.tableQR`]="{ item }">
            <v-tooltip top v-if="hasInvalidQR(item)">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">{{ item.tableQR }}</span>
              </template>
              <span
                >{{ "Referer: " + (item.referer || "-") }} <br />{{
                  "User agent: " + (item.userAgent || "-")
                }}</span
              >
            </v-tooltip>
            <span v-else>{{ item.tableQR }}</span>

            <v-btn
              v-if="hasInvalidQR(item)"
              class="mx-2"
              fab
              dark
              x-small
              @click="openChangeTableDialog(item)"
              color="black"
            >
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.price`]="{ item }">
            {{ formatPrice(item.price) }}
          </template>
          <template v-slot:[`item.totalPrice`]="{ item }">
            <strong>{{ formatPrice(item.price * item.quantity) }}</strong>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <OrderEditTableDialog
      :selectedOrder="selectedOrder"
      :dialog="dialog"
      :actives-q-r="activesQR"
      @cancel="dialogCancel"
      @changeTableFromDialog="onChangeTable"
      ref="orderEditTableDialogRef"
    ></OrderEditTableDialog>
  </div>
</template>

<script>
import OrderEditTableDialog from "@/components/admin/order/OrderEditTableDialog";
import { OrdersHistoryTableHeader } from "@/utils/tableHeaderconstants";
import { updateOrder } from "@/collections/orders";
let xlsx = require("json-as-xlsx");

export default {
  name: "order-history",
  props: {
    orders: Array,
    activesQR: Array,
    search: String
  },
  components: {
    OrderEditTableDialog
  },
  data() {
    return {
      dialog: false,
      selectedOrder: null,
      headers: [...OrdersHistoryTableHeader]
    };
  },
  computed: {
    reversedOrders() {
      return [...this.orders].reverse();
    },
    totalOrders() {
      let orders = this.arrayGroupBy(this.orders, "time");
      return Object.keys(orders || [])?.length;
    },
    totalLineOrders() {
      return this.orders?.length;
    },
    total() {
      let total = 0;
      this.orders?.forEach(order => {
        total += order.price * order.quantity;
      });

      return total;
    }
  },
  methods: {
    hasInvalidQR(order) {
      return (
        !order.tableQR || order.tableQR === "" || order.tableQR === "NO QR"
      );
    },
    exportToExcel(excelName) {
      let data = [
        {
          sheet: "Orders",
          columns: [
            {
              label: "HORA",
              value: row => this.dayFormatLLAndTime(row.time)
            },
            {
              label: "PEDIDO",
              value: row => row.name + this.weight(row)
            },
            {
              label: "TIPO DE PRODUCTO",
              value: row => this.getType(row)
            },
            {
              label: "ESTADO",
              value: row => (row.isPending ? "Pendientes" : "Hechos")
            },
            {
              label: "CANTIDAD",
              value: row => row.quantity
            },
            {
              label: "MESA",
              value: row => row.tableQR
            },
            {
              label: "PRECIO",
              value: row => this.formatPriceWithoutCurrency(row.price)
            },
            {
              label: "BASE IMPONIBLE",
              value: row =>
                this.formatPriceWithoutCurrency(
                  this.getTaxBase(row.price * row.quantity)
                )
            },
            {
              label: "IVA (10%)",
              value: row =>
                this.formatPriceWithoutCurrency(
                  this.getIVA(row.price * row.quantity)
                )
            },
            {
              label: "TOTAL",
              value: row =>
                this.formatPriceWithoutCurrency(row.price * row.quantity)
            }
          ],
          content: this.orders
        }
      ];

      let settings = {
        fileName: excelName, // Name of the spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeOptions: {} // Style options from https://github.com/SheetJS/sheetjs#writing-options
      };

      xlsx(data, settings); // Will download the excel file
    },
    weight(order) {
      return order.weight ? " \xa0\xa0" + order.weight + "Kg" : " ";
    },
    getType(order) {
      if (order.product_type_id === this.$store.state.productTypeIds.drinks) {
        return "Bebida";
      }
      return "Comida";
    },
    openChangeTableDialog(order) {
      this.selectedOrder = order;
      this.dialog = true;
      console.log(order);
    },
    async onChangeTable(selectedQR) {
      await updateOrder(this.selectedOrder.id, { tableQR: selectedQR });

      this.resetAll();
      this.$emit("changeTableFromOrdersHistory");
    },
    dialogCancel() {
      this.dialog = false;
    },
    resetAll() {
      this.dialog = false;
      this.selectedOrder = null;
    }
  }
};
</script>

<style scoped lang="scss">
.day-format {
  font-size: 10px;
}

.table-scroll {
  max-width: 100%;
  overflow-x: auto;
}
</style>
